<template>
  <div>
    <h5 class="mb-4"><i class="dot"></i>사외수급업체 서류평가(사전) 작성</h5>
    <div class="writeGridContainer">
      <div class="writeGridLineItem">
        <div>서류평가 작성</div>
        <div class="button-container">
          <vs-button class="action-button" color="secondary" :disabled="readonly" @click="onClickWrite">사외수급업체 서류평가 작성</vs-button>
          <vs-button class="action-button" color="secondary" type="border" @click="onClickView">작성 사외수급업체 서류평가 보기</vs-button>
        </div>
      </div>
    </div>

    <PopupBoard v-model="isViewPopupBoard" :boardId="897" :propsType="typePopupBoard" :readonly="readonly" :form-overwrite="defaultInfo" @successCreate="successCreate" />
  </div>
</template>

<script>
import PopupBoard from "@/components/popup-board/PopupBoard.vue";

export default {
  components: {
    PopupBoard,
  },
  props: {
    isPrint: Boolean,
    readonly: { type: Boolean, default: false },
    board: Object,
    value: Object,
    header: Object,
  },
  data() {
    return {
      form: this.value,
      isViewPopupBoard: false,
      typePopupBoard: "list",

      사외수급업체_서류평가_작성됐는가: false,
      서류평가합산: 0, // 사외수급업체 서류평가 목록 (체크용)
      isNotApproval: false, // (처리부서) 결재자가 아닌경우 true
      defaultInfo: {},  // 사외수급업체 서류평가 기본 작성 정보로 전달할 값
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form = value;
        this.defaultInfo = {
          body : {
            stdInfo: {
              field_id: this.form.stdInfo.field_id || 0,
              field_name: this.form.stdInfo.field_name || '',
              field_address: this.form.stdInfo.field_address || '',

              section: this.myInfo.section || '', // 소속1
              department: this.myInfo.department || '', // 소속2
              rank: this.myInfo.rank || '', // 직책
              writer_name: this.myInfo.name, // 작성자
              date: new Date().format("yyyy-MM-dd"), // 작성일
            },
            구분 : {
              업체명: this.form.안전작업허가서정보.작업업체명.id || '',
              공사명: this.form.안전작업허가서정보.공사작업명 || '',
              작업기간: this.form.안전작업허가서정보.작업기간 || { sDate: '', eDate: '' },
              공사금액: this.form.안전작업허가서정보.공사금액 || '',
            },
            업체명 : this.form.안전작업허가서정보.작업업체명 || undefined,
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    // board: {
    //   immediate: true,
    //   deep: true,
    //   handler (/*value*/) {
    //     if (this.board) {
    //       // 최종결재자인경우 처리부서등록 on
    //       if (!this.form.처리부서등록 && this.board.approvalLine && this.board.approvalLine.length > 0) {
    //         if (this.board.approvalLine[this.board.approvalLine.length - 1].user_id === this.myInfo.id) {
    //           this.form.처리부서등록 = true;
    //         }
    //       }
    //     }
    //   }
    // },
  },
  created() {
    this.checkRelatedBoard();
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
  },
  methods: {
    validate() {
      if (this.사외수급업체_서류평가_작성됐는가 === false) {
        return this.isNotApproval ? "처리부서가 아닙니다" : "서류평가를 작성해주세요.";
      }
    },
    successCreate() {
      // 결재자가 처리부서인지 검색
      const 나는_처리부서_소속인가 = this.board.documentCompany && this.board.documentCompany.virtual_company_id === this.myInfo.virtual_company_id;

      if (나는_처리부서_소속인가 /*그렇다면, 897번 게시글의 서류평가 합산을 조회한다*/) {
        this.checkRelatedBoard(false)
      } else { // 처리부서가 아닌경우 (validate 메세지 변경)
        this.isNotApproval = true;
      }
    },
    onClickWrite() {
      this.typePopupBoard = "write";
      this.isViewPopupBoard = true;
    },
    onClickView() {
      this.typePopupBoard = "list";
      this.isViewPopupBoard = true;
    },

    // 현재 포스트와 연결된 897번 게시판의 모든 글을 불러온다.
    // 불러온보드에서 서류평가 각항목의 값을 합산한다
    async checkRelatedBoard(useCache = true) {
      if (!this.postId) return;

      this.서류평가합산 = 0 // 초기화
      const conditions = [];
      conditions.push({ key: "parentsPostId", operator: "=", value: this.postId });
      const options = {
        projectId: this.projectId,
        boardId: 897,
        page: 1,
        perPage: 10,
        orderTarget: "created_at",
        orderDirection: "desc",
        conditions,
      };
      const response = await this.$store.dispatch("board/LOAD_POST_LIST", options, useCache);

      response.data.forEach((data) => {
        const body = JSON.parse(data.post_content).body;

        if (body.evaluationList && body.evaluationList.length > 0) {
          this.서류평가합산 += body.evaluationList.reduce((acc, item) => {
            if (item.label === '서류평가') {
              return item.childs.reduce((acc, child) => {
                return acc + child.value;
              }, 0);
            }
            return acc;
          }, 0);
          // 세부항목 구분하지 않음
          // body.evaluationList.reduce((acc, item) => {
          //   if (item.label === '서류평가') {
          //     item.childs.forEach(child => {
          //       if (child.label === '리더십') {
          //         acc.리더십 += child.value;
          //       } else if (child.label === '근로자참여') {
          //         acc.근로자참여 += child.value;
          //       } else if (child.label === '위험요인 파악 및 제거·대체·통제') {
          //         acc.위험요인 += child.value;
          //       } else if (child.label === '비상조치계획') {
          //         acc.비상조치계획 += child.value;
          //       }
          //     });
          //   }
          //   return acc;
          // }, this.서류평가);
        }
      });

      // const totalScore = this.서류평가.리더십 + this.서류평가.근로자참여 + this.서류평가.위험요인 + this.서류평가.비상조치계획;
      if (this.서류평가합산 > 0) {
        this.사외수급업체_서류평가_작성됐는가 = true;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.button-container {
  display: flex;
  gap: 16px;

  .action-button {
    margin-left: 16px;

    &:first-child {
      margin-left: 0;
    }
  }
}

// 모바일 반응형 디자인 (768px 이하)
@media (max-width: 768px) {
  .button-container {
    flex-direction: column;
    gap: 12px;

    .action-button {
      width: 100%;
      margin-left: 0;
      min-height: 44px; // 터치 친화적 높이
    }
  }

  .writeGridLineItem {
    flex-direction: column;
    gap: 16px;

    > div:first-child {
      margin-bottom: 8px;
    }
  }
}

// 인쇄 시 PC 레이아웃 강제 적용
@media print {
  .button-container {
    flex-direction: row !important;
    gap: 16px !important;

    .action-button {
      width: auto !important;
      margin-left: 16px !important;

      &:first-child {
        margin-left: 0 !important;
      }
    }
  }

  .writeGridLineItem {
    flex-direction: row !important;
    gap: initial !important;
  }
}
</style>
